import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { Box } from "@mui/material";

import Page from "./Page";

import SyncReset from "../ui/SyncReset";
import ForensicRequestManager from "../ui/ForensicRequestManager";
import SqlRecoveryManager from "../ui/SqlRecoveryManager";
import useApi from "../../hooks/useApi";

const Synchronization = () => {
  const navigate = useNavigate();
  const { getData } = useApi();
  const getDataRef = useRef(getData);
  const currentUserId = useSelector((state) => state.authentication.userId);
  const [activeTool, setActiveTool] = useState("forensicExtracts");
  const [canAccessSupport, setCanAccessSupport] = useState(false);

  useEffect(() => {
    getDataRef.current = getData;
  }, [getData]);

  useEffect(() => {
    let isMounted = true;

    const loadAccess = async () => {
      if (!currentUserId) {
        if (isMounted) setCanAccessSupport(false);
        return;
      }

      const response = await getDataRef.current({
        entityName: "User",
        id: currentUserId,
      });

      if (!isMounted) return;

      if (response?.isSuccessful) {
        setCanAccessSupport(
          response?.data?.permissions?.canAccessSupport === true,
        );
      } else {
        setCanAccessSupport(false);
      }
    };

    loadAccess();

    return () => {
      isMounted = false;
    };
  }, [currentUserId]);

  const handleToolbarClick = (item) => {
    switch (item) {
      case "orderDashboard":
        navigate("/orderdashboard");
        break;
      case "syncSupport":
        navigate("/sync-support");
        break;
      case "forensicExtracts":
        setActiveTool("forensicExtracts");
        break;
      case "sqlRecovery":
        setActiveTool("sqlRecovery");
        break;
    }
  };

  return (
    <>
      <Page
        pageName="synchronization"
        includeToolbar
        onToolItemClick={handleToolbarClick}
        items={[
          { name: "forensicExtracts", iconName: "FindInPage" },
          { name: "sqlRecovery", iconName: "Code" },
          {
            name: "syncSupport",
            iconName: "SupportAgent",
            hide: !canAccessSupport,
          },
          { name: "orderDashboard", iconName: "ShoppingCart" },
        ]}
      >
        <Box
          display="flex"
          gap={2}
          flexWrap="wrap"
        >
          <SyncReset />
          {activeTool === "sqlRecovery" ? (
            <SqlRecoveryManager />
          ) : (
            <ForensicRequestManager />
          )}
        </Box>
      </Page>
    </>
  );
};

export default Synchronization;
